import { ApolloProvider } from "@apollo/client";
import { ObjectInUseModal } from "components/modal/object-in-use-modal";
import ValidationModal from "components/modal/validation-modal";
import Toasts from "components/notification/toast";
import { local } from 'data/lib/local-json';
import { UrlChecker } from 'data/lib/url-property-folder-check';
// Sockets
import { folderChannel, propertyChannel, userChannel } from "data/websocket/sharedChannel";
// Graphql client
import { apolloClient } from "data/_apollo-client";
// Features
import toggles from 'feature-toggles';
import _ from "lodash";
import 'primeicons/primeicons.css';
// Global & Vendor Styles
import 'primereact/resources/primereact.min.css';
import React from "react";
import ReactDOM from "react-dom";
// Top-level Components
import Routes from "routes";







const profile = local("auth.profile")
if(!_.isNil(profile)) userChannel.connectUser(_.get(profile, "user_id"))

const folderId = _.last(local("folderPath"))
if(!_.isNil(folderId)) folderChannel.handleFolderSelection(folderId)

const propId = local("property")
if(!_.isNil(propId)) propertyChannel.handlePropertySelection(propId)

// Top level components
toggles.get().then(() => {
  ReactDOM.render(
    <ApolloProvider client={apolloClient}>
      <Toasts />
      <ValidationModal />
      <ObjectInUseModal />
      <Routes />
      <UrlChecker/>
    </ApolloProvider>,
    document.getElementById("mount")
  )
})
